module.exports = __webpack_public_path__ + "static/media/project-pm.b1bf8969.jpg";